module.exports = __webpack_public_path__ + "img/484.13ed8398.png";